import { render } from "./InputNumber.vue?vue&type=template&id=22e8a526&ts=true"
import script from "./InputNumber.vue?vue&type=script&lang=ts"
export * from "./InputNumber.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__